import { fishData } from './fishData';
import { bugData } from './bugData';
import { seaData } from './seaData';

export const creatureDatabase = {
  // FISH DATABASE
  "Bitterling": {
    rarity: "Common",
    location: "River",
    timeAvailable: "All day",
    availableHours: Array.from({length: 24}, (_, i) => i),
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 900,
    northMonths: [0,1,2,10,11], 
    southMonths: [4,5,6,7,8], 
    description: "I caught a bitterling! It's mad at me, but only a little.",
  },

  "Pale Chub": {
    rarity: "Uncommon", 
    location: "River",
    timeAvailable: "9 a.m - 4 p.m",
    availableHours: [9,10,11,12,13,14,15],
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 200,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a pale chub! That name seems a bit judgy...",
  },

  "Crucian Carp": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "All day",
    availableHours: Array.from({length: 24}, (_, i) => i),
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 160,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a crucian carp! My skills are sharp!",
  },

    "Dace": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 240,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a crucian carp! My skills are sharp!",
  },

    "Carp": {
    rarity: "Common",
    location: "Pond", 
    timeAvailable: "All Day",
    shadow: "Large",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a carp! If I catch another, they can carpool!",
  },

    "Koi": {
    rarity: "Uncommon",
    location: "Pond", 
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Large",
    spawnRequirements: "Catch 20 total fish",
    price: 4000,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a koi! I don't know why it's so shy... or such a bad speller...",
  },
  
    "Goldfish": {
    rarity: "Common",
    location: "Pond", 
    timeAvailable: "All day",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 1300,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a goldfish! It's worth its weight in fish!"
  },

    "Pop Eyed Goldfish": {
    rarity: "Uncommon",
    location: "Pond", 
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 1300,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a pop-eyed goldfish! It looks so...surprised!"
  },

    "Ranchu Goldfish": {
    rarity: "Uncommon",
    location: "Pond", 
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Small",
    spawnRequirements: "Catch 20 total fish",
    price: 4500,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a ranchu goldfish! But I prefer balsamicu goldfish!"
  },

    "Killifish": {
    rarity: "Uncommon",
    location: "Pond", 
    timeAvailable: "All Day",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [3,4,5,6,7], 
    southMonths: [9,10,11,0,1], 
    description: "I caught a killifish! The streams are safe again."
  },

    "Crawfish": {
    rarity: "Common",
    location: "Pond", 
    timeAvailable: "All Day",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 200,
    northMonths: [3,4,5,6,7,8], 
    southMonths: [9,10,11,0,1,2], 
    description: "I caught a crawfish! Or else it's a lobster, and I'm a giant!"
  },

    "Snapping Turtle": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "9 p.m - 4 a.m",
    shadow: "Large",
    spawnRequirements: "Appears from the start of the game",
    price: 5000,
    northMonths: [3,4,5,6,7,8,9], 
    southMonths: [9,10,11,0,1,2,3], 
    description: "I caught a snapping turtle! How can it snap without fingers?"
  },

    "Tadpole": {
    rarity: "Common",
    location: "Pond", 
    timeAvailable: "All Day",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 100,
    northMonths: [2,3,4,5,6], 
    southMonths: [8,9,10,11,0], 
    description: "I caught a tadpole... It's just a tad small."
  },

    "Frog": {
    rarity: "Common",
    location: "Pond", 
    timeAvailable: "All Day",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 120,
    northMonths: [4,5,6,7], 
    southMonths: [10,11,0,1], 
    description: "I caught a frog! Or it's a new neighbor... and I have some apologizing to do."
  },

    "Freshwater Goby": {
    rarity: "Uncommon",
    location: "River", 
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 400,
    northMonths: [4,5,6,7], 
    southMonths: [10,11,0,1], 
    description: "I caught a freshwater goby! Time to go bye-bye!"
  },

    "Loach": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "All Day",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 400,
    northMonths: [2,3,4], 
    southMonths: [8,9,10], 
    description: "I caught a loach! It's...looking at me with reproach."
  },

    "Catfish": {
    rarity: "Common",
    location: "Pond", 
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Large",
    spawnRequirements: "Appears from the start of the game",
    price: 800,
    northMonths: [2,3,4], 
    southMonths: [8,9,10], 
    description: "I caught a catfish! I'm more of a dogfish person..."
  },

    "Giant Snakehead": {
    rarity: "Rare",
    location: "Pond", 
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Large",
    spawnRequirements: "Catch 50 total fish",
    price: 5500,
    northMonths: [5,6,7], 
    southMonths: [11,0,1], 
    description: "I caught a giant snakehead! Um...but I asked for a medium?"
  },

  "Bluegill": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 180,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a bluegill! Do you think it calls me \"pinklung\"?"
  },

  "Yellow Perch": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "All Day",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [9,10,11,0,1,2], 
    southMonths: [3,4,5,6,7,8], 
    description: "I caught a yellow perch! Those yellow birds have to sit somewhere!"
  },

  "Black Bass": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "All Day",
    shadow: "Large",
    spawnRequirements: "Appears from the start of the game",
    price: 400,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a black bass! The most metal of all fish!"
  },

  "Tilapia": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "All Day",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 800,
    northMonths: [5,6,7,8,9], 
    southMonths: [11,0,1,2,3], 
    description: "I caught a tilapia! It makes me happy-a!"
  },

  "Pike": {
    rarity: "Uncommon",
    location: "River", 
    timeAvailable: "All Day",
    shadow: "Very Large",
    spawnRequirements: "Catch 20 total fish",
    price: 1800,
    northMonths: [8,9,10,11], 
    southMonths: [2,3,4,5], 
    description: "I caught a pike! Think a swordfish would be up for a duel?"
  },

  "Pond Smelt": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "All Day",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 400,
    northMonths: [11,0,1], 
    southMonths: [5,6,7], 
    description: "I caught a pond smelt! Whoever smelt it dealt it!"
  },

  "Sweetfish": {
    rarity: "Common",
    location: "River", 
    timeAvailable: "All Day",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 900,
    northMonths: [6,7,8], 
    southMonths: [0,1,2], 
    description: "I caught a sweetfish! Hope it's not artificially sweet!"
  },

  "Cherry Salmon": {
    rarity: "Uncommon",
    location: "River (clifftop)", 
    timeAvailable: "Mar - Jun (North), Sep - Dec (South)\n 4 p.m - 9 a.m\nSep - Nov (North), Mar - May (South)\nAll Day",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [2,3,4,5,8,9,10], 
    southMonths: [2,3,4,8,9,10,11], 
    description: "I caught a cherry salmon! It's the perfect topper for a marlin sundae!"
  },


  "Char": {
    rarity: "Rare",
    location: "River (clifftop)", 
    timeAvailable: "Mar - Jun (North), Sep - Dec (South)\n 4 p.m - 9 a.m\nSep - Nov (North), Mar - May (South)\nAll Day",
    shadow: "Medium",
    spawnRequirements: "Catch 20 total fish",
    price: 3800,
    northMonths: [2,3,4,5,8,9,10], 
    southMonths: [2,3,4,8,9,10,11], 
    description: "I caught a char! Now I'm gonna sit on it!"
  },

  "Golden Trout": {
    rarity: "Rare",
    location: "River (clifftop)", 
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Medium",
    spawnRequirements: "Catch 100 total fish",
    price: 15000,
    northMonths: [2,3,4,8,9,10], 
    southMonths: [2,3,4,8,9,10], 
    description: "I caught a golden trout! But the real treasure? Friendship."
  },

  "Stringfish": {
    rarity: "Rare",
    location: "River (clifftop)", 
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Very Large",
    spawnRequirements: "Catch 100 total fish",
    price: 15000,
    northMonths: [11,0,1,2], 
    southMonths: [5,6,7,8], 
    description: "OH MY GOSH! I caught a stringfish! Five more and I'll have a guitarfish!"
  },

  "Salmon": {
    rarity: "Common",
    location: "River (mouth)", 
    timeAvailable: "All Day",
    shadow: "Large",
    spawnRequirements: "Appears from the start of the game",
    price: 700,
    northMonths: [8], 
    southMonths: [2], 
    description: "I caught a salmon! It's all upstream from here!"
  },

  "King Salmon": {
    rarity: "Uncommon",
    location: "River (mouth)", 
    timeAvailable: "All Day",
    shadow: "Very Large",
    spawnRequirements: "Catch 20 total fish",
    price: 1800,
    northMonths: [8], 
    southMonths: [2], 
    description: "WOO-HOO! I caught a king salmon! Checkmate!"
  },

  "Mitten Crab": {
    rarity: "Rare",
    location: "River",
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Small",
    spawnRequirements: "Catch 20 total fish",
    price: 200,
    northMonths: [8,9,10], 
    southMonths: [2,3,4], 
    description: "I caught a mitten crab! One more and I'm ready for winter!"
  },

  "Guppy": {
    rarity: "Rare",
    location: "River",
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Tiny",
    spawnRequirements: "Catch 20 total fish",
    price: 1300,
    northMonths: [3,4,5,6,7,8,9,10], 
    southMonths: [9,10,11,0,1,2,3,4], 
    description: "I caught a guppy! Welcome to the team, newbie!"
  },

  "Nibble Fish": {
    rarity: "Rare",
    location: "River",
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Tiny",
    spawnRequirements: "Catch 20 total fish",
    price: 1500,
    northMonths: [4,5,6,7,8], 
    southMonths: [10,11,0,1,2], 
    description: "I caught a nibble fish! Come to think of it, I could use a bite!"
  },

  "Angelfish": {
    rarity: "Uncommon",
    location: "River",
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Small",
    spawnRequirements: "Catch 20 total fish",
    price: 3000,
    northMonths: [4,5,6,7,8,9], 
    southMonths: [10,11,0,1,2,3], 
    description: "I caught an angelfish! That other fish told me to do it!"
  },

  "Betta": {
    rarity: "Uncommon",
    location: "River",
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Small",
    spawnRequirements: "Catch 20 total fish",
    price: 2500,
    northMonths: [4,5,6,7,8,9], 
    southMonths: [10,11,0,1,2,3], 
    description: "I caught a betta! I betta not drop it!"
  },

  "Neon Tetra": {
    rarity: "Uncommon",
    location: "River",
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 500,
    northMonths: [3,4,5,6,7,8,9,10], 
    southMonths: [9,10,11,0,1,2,3,4], 
    description: "I caught a neon tetra! Wasn't hard to track."
  },

  "Rainbowfish": {
    rarity: "Uncommon",
    location: "River",
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 800,
    northMonths: [4,5,6,7,8,9], 
    southMonths: [10,11,0,1,2,3], 
    description: "I caught a rainbowfish! Where's my pot of goldfish?"
  },

  "Piranha": {
    rarity: "Rare",
    location: "River",
    timeAvailable: "9 a.m - 4 p.m",
    shadow: "Small",
    spawnRequirements: "Catch 20 total fish",
    price: 2500,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a piranha! Sure hope it was the only one!"
  },

  "Arowana": {
    rarity: "Uncommon",
    location: "River",
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Large",
    spawnRequirements: "Catch 50 total fish",
    price: 10000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught an arowana! I'd make a joke but I don't 'wana."
  },

  "Dorado": {
    rarity: "Rare",
    location: "River",
    timeAvailable: "4 a.m - 9 p.m",
    shadow: "Very Large",
    spawnRequirements: "Catch 100 total fish",
    price: 15000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a dorado! ♪I say \"Dorado\", you say \"Doraydo.\"♪"
  },

  "Gar": {
    rarity: "Uncommon",
    location: "River",
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Very Large",
    spawnRequirements: "Catch 50 total fish",
    price: 6000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a gar! Yar! It's a gar! Har Har!"
  },

  "Arapaima": {
    rarity: "Rare",
    location: "River",
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Huge",
    spawnRequirements: "Catch 50 total fish",
    price: 10000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught an arapaima! How did it get here? Arapaiknow!"
  },

  "Saddled Bichir": {
    rarity: "Uncommon",
    location: "River",
    timeAvailable: "9 p.m - 4 a.m",
    shadow: "Large",
    spawnRequirements: "Catch 20 total fish",
    price: 4000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "Wow! A saddled bichir! And me without my tiny riding crop..."
  },

  "Sturgeon": {
    rarity: "Uncommon",
    location: "River (mouth)",
    timeAvailable: "All Day",
    shadow: "Huge",
    spawnRequirements: "Catch 20 total fish",
    price: 10000,
    northMonths: [8,9,10,11,0,1], 
    southMonths: [2,3,4,5,6,7,8], 
    description: "I caught a sturgeon! Wonder if it can perform sturgery..."
  },

  "Sea Butterfly": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [11,0,1,2], 
    southMonths: [5,6,7,8], 
    description: "I caught a sea butterfly! Try not to confuse it for a sea moth!"
  },

  "Sea Horse": {
    rarity: "Common",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 1100,
    northMonths: [3,4,5,6,7,8,9,10], 
    southMonths: [9,10,11,0,1,2,3,4], 
    description: "I caught a sea horse! But... where's its sea jockey?"
  },

  "Clown Fish": {
    rarity: "Common",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Tiny",
    spawnRequirements: "Appears from the start of the game",
    price: 650,
    northMonths: [3,4,5,6,7,8], 
    southMonths: [9,10,11,0,1,2], 
    description: "I caught a clown fish! How many can fit in a carfish?"
  },

  "Surgeonfish": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [3,4,5,6,7,8], 
    southMonths: [9,10,11,0,1,2], 
    description: "I caught a surgeonfish! Scalpel! Forceps! Fish hook!"
  },

  "Butterfly Fish": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [3,4,5,6,7,8], 
    southMonths: [9,10,11,0,1,2], 
    description: "I caught a butterfly fish! Did it change from a caterpillar fish?"
  },

  "Napoleonfish": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "4 a.m - 9 p.m",
    shadow: "Huge",
    spawnRequirements: "Catch 50 total fish",
    price: 10000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a Napoleonfish! It's not as big as it thinks!"
  },

  "Zebra Turkeyfish": {
    rarity: "Common",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 500,
    northMonths: [3,4,5,6,7,8,9,10], 
    southMonths: [9,10,11,0,1,2,3,4], 
    description: "I caught a zebra turkeyfish! Land, air, water—make up your mind!"
  },

  "Blowfish": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "9 p.m - 4 a.m",
    shadow: "Medium",
    spawnRequirements: "Catch 20 total fish",
    price: 5000,
    northMonths: [10,11,0,1], 
    southMonths: [4,5,6,7], 
    description: "I caught a blowfish! I'm blown away!"
  },

  "Puffer Fish": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "9 p.m - 4 a.m",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 250,
    northMonths: [6,7,8], 
    southMonths: [0,1,2], 
    description: "I caught a puffer fish! I thought you would be tougher, fish!"
  },

  "Anchovy": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "4 a.m - 9 p.m",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 200,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught an anchovy! Stay away from my pizza!"
  },

  "Horse Mackerel": {
    rarity: "Common",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Small",
    spawnRequirements: "Appears from the start of the game",
    price: 150,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a horse mackerel! Of course, mack...er...el."
  },

  "Barred Knifejaw": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Medium",
    spawnRequirements: "Catch 20 total fish",
    price: 5000,
    northMonths: [2,3,4,5,6,7,8,9,10], 
    southMonths: [8,9,10,11,0,1,2,3,4], 
    description: "I caught a barred knifejaw! They must have a hard time eating!"
  },

  "Sea Bass": {
    rarity: "Common",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Very Large",
    spawnRequirements: "Appears from the start of the game",
    price: 400,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a sea bass! No, wait—it's at least a C+!"
  },

  "Red Snapper": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Large",
    spawnRequirements: "Appears from the start of the game",
    price: 3000,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a red snapper! It looks pretty dapper!"
  },

  "Dab": {
    rarity: "Common",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [9,10,11,0,1,2,3], 
    southMonths: [3,4,5,6,7,8,9], 
    description: "I caught a dab! Not bad!"
  },

  "Olive Flounder": {
    rarity: "Common",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Very Large",
    spawnRequirements: "Appears from the start of the game",
    price: 800,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught an olive flounder! That's not the pits!"
  },

  "Squid": {
    rarity: "Common",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Medium",
    spawnRequirements: "Appears from the start of the game",
    price: 500,
    northMonths: [11,0,1,2,3,4,5,6,7], 
    southMonths: [5,6,7,8,9,10,11,0,1], 
    description: "I caught a squid! It's off the hook!\n\nI caught a squid! I had an inkling I might!"
  },

  "Moray Eel": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Long",
    spawnRequirements: "Catch 20 total fish",
    price: 2000,
    northMonths: [7,8,9], 
    southMonths: [1,2,3], 
    description: "I caught a moray eel! When you're in love, that's a moray!"
  },

  "Ribbon Eel": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Long",
    spawnRequirements: "Appears from the start of the game",
    price: 600,
    northMonths: [5,6,7,8,9], 
    southMonths: [11,0,1,2,3], 
    description: "I caught a ribbon eel! Can it tie itself into a bow?"
  },

  "Tuna": {
    rarity: "Rare",
    location: "Pier",
    timeAvailable: "All Day",
    shadow: "Huge",
    spawnRequirements: "Catch 50 total fish",
    price: 7000,
    northMonths: [10,11,0,1,2,3], 
    southMonths: [4,5,6,7,8,9,10], 
    description: "I caught a tuna! It's a little off-key!"
  },

  "Blue Marlin": {
    rarity: "Rare",
    location: "Pier",
    timeAvailable: "All Day",
    shadow: "Huge",
    spawnRequirements: "Catch 50 total fish",
    price: 10000,
    northMonths: [10,11,0,1,2,3,6,7,8], 
    southMonths: [0,1,2,4,5,6,7,8,9], 
    description: "I caught a blue marlin! Listen to this fish. It's got a point."
  },

  "Giant Trevally": {
    rarity: "Rare",
    location: "Pier",
    timeAvailable: "All Day",
    shadow: "Very Large",
    spawnRequirements: "Catch 20 total fish",
    price: 4500,
    northMonths: [4,5,6,7,8,9], 
    southMonths: [10,11,0,1,2,3], 
    description: "I caught a giant trevally! Yeah, I'm pretty well-trevalled."
  },

  "Mahi Mahi": {
    rarity: "Rare",
    location: "Pier",
    timeAvailable: "All Day",
    shadow: "Very Large",
    spawnRequirements: "Catch 50 total fish",
    price: 6000,
    northMonths: [4,5,6,7,8,9], 
    southMonths: [10,11,0,1,2,3], 
    description: "I caught a mahi-mahi! It's all mahine-mahine."
  },

  "Ocean Sunfish": {
    rarity: "Rare",
    location: "Sea",
    timeAvailable: "4 a.m - 9 p.m",
    shadow: "Very Large (finned)",
    spawnRequirements: "Catch 20 total fish",
    price: 4000,
    northMonths: [6,7,8], 
    southMonths: [0,1,2], 
    description: "I caught an ocean sunfish! Good thing I'm wearing ocean sunscreen!"
  },

  "Ray": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "4 a.m - 9 p.m",
    shadow: "Very Large",
    spawnRequirements: "Catch 20 total fish",
    price: 3000,
    northMonths: [7,8,9,10], 
    southMonths: [1,2,3,4], 
    description: "I caught a ray! A few more and I'll have a tan!"
  },

  "Saw Shark": {
    rarity: "Rare",
    location: "Sea",
    timeAvailable: "4 a.m - 9 p.m",
    shadow: "Very Large (finned)",
    spawnRequirements: "Catch 50 total fish",
    price: 12000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a saw shark! You could call it a sea saw!"
  },

  "Hammerhead Shark": {
    rarity: "Rare",
    location: "Sea",
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Very Large (finned)",
    spawnRequirements: "Catch 20 total fish",
    price: 8000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a hammerhead shark! I hit the nail on the head!"
  },

  "Great White Shark": {
    rarity: "Rare",
    location: "Sea",
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Very Large (finned)",
    spawnRequirements: "Catch 50 total fish",
    price: 15000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a great white shark! Watch out for its jaws!"
  },

  "Whale Shark": {
    rarity: "Rare",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Very Large (finned)",
    spawnRequirements: "Catch 50 total fish",
    price: 13000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "Thar she blows! I caught a whale shark! I'm tellin' ya, it was thiiiiiiiiiiiiiiiiiiiis big!"
  },

  "Suckerfish": {
    rarity: "Rare",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Very Large (finned)",
    spawnRequirements: "Catch 20 total fish",
    price: 1500,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a suckerfish! I thought it was a shark! Oh, wait——now I get it. \"Sucker\"..."
  },

  "Football Fish": {
    rarity: "Uncommon",
    location: "Sea",
    timeAvailable: "4 p.m - 9 a.m",
    shadow: "Large",
    spawnRequirements: "Catch 20 total fish",
    price: 2500,
    northMonths: [10,11,0,1,2], 
    southMonths: [4,5,6,7,8], 
    description: "I caught a football fish! Some countries call it a soccer fish!"
  },

  "Oarfish": {
    rarity: "Rare",
    location: "Sea",
    timeAvailable: "All Day",
    shadow: "Huge",
    spawnRequirements: "Catch 50 total fish",
    price: 9000,
    northMonths: [11,0,1,2,3,4], 
    southMonths: [5,6,7,8,9,10], 
    description: "I caught an oarfish! I hope I catch morefish!"
  },

  "Barreleye": {
    rarity: "Rare",
    location: "Sea",
    timeAvailable: "9 p.m - 4 a.m",
    shadow: "Small",
    spawnRequirements: "Catch 100 total fish",
    price: 15000,
    northMonths: [11,0,1,2,3,4], 
    southMonths: [5,6,7,8,9,10], 
    description: "I caught a barreleye! Like eyeing fish in a barrel!"
  },

  "Coelacanth": {
    rarity: "Rare",
    location: "Sea (raining)",
    timeAvailable: "All Day",
    shadow: "Huge",
    spawnRequirements: "Catch 100 total fish",
    price: 15000,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "Blast from the past! I caught a coelacanth! Think positive! Be a coela-CAN!"
  },

  // BUGS DATABASE
  "Common Butterfly": {
    rarity: "Common",
    location: "Flying",
    timeAvailable: "4 a.m - 7 p.m", 
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 160,
    northMonths: [8,9,10,11,0,1,2,3,4,5], 
    southMonths: [2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a common butterfly! They often flutter by!"
  },

  "Yellow Butterfly": {
    rarity: "Common",
    location: "Flying",
    timeAvailable: "4 a.m - 7 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 160,
    northMonths: [2,3,4,5,8,9], 
    southMonths: [2,3,8,9,10,11], 
    description: "I caught a yellow butterfly! Shouldn't all BUTTERflies be yellow?"
  },

  "Tiger Butterfly": {
    rarity: "Uncommon",
    location: "Flying",
    timeAvailable: "4 a.m - 7 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 240,
    northMonths: [2,3,4,5,6,7,8], 
    southMonths: [8,9,10,11,0,1,2], 
    description: "I caught a tiger butterfly! I've earned my stripes!"
  },

  "Peacock Butterfly": {
    rarity: "Uncommon",
    location: "Flying near blue, purple, and black flowers",
    timeAvailable: "4 a.m - 7 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 2500,
    northMonths: [2,3,4,5], 
    southMonths: [8,9,10,11], 
    description: "I caught a peacock butterfly! Now it's my turn to strut my stuff!"
  },

  "Common Bluebottle": {
    rarity: "Common",
    location: "Flying",
    timeAvailable: "4 a.m - 7 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [3,4,5,6,7], 
    southMonths: [9,10,11,0,1], 
    description: "I caught a common bluebottle! I'll put it in a rare green jar!"
  },

  "Paper Kite Butterfly": {
    rarity: "Uncommon",
    location: "Flying near flowers",
    timeAvailable: "8 a.m - 7 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a paper kite butterfly! Do I read it, fly it, or spread it on toast?"
  },

  "Great Purple Emperor": {
    rarity: "Rare",
    location: "Flying near flowers",
    timeAvailable: "4 a.m - 7 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 50 total bugs",
    price: 3000,
    northMonths: [4,5,6,7], 
    southMonths: [10,11,0,1], 
    description: "I caught a great purple emperor! Its purple reign is over now!"
  },

  "Monarch Butterfly": {
    rarity: "Common",
    location: "Flying near flowers",
    timeAvailable: "4 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 140,
    northMonths: [8,9,10], 
    southMonths: [2,3,4], 
    description: "I caught a monarch butterfly! Guess the butterflies are a democracy now!"
  },

  "Emperor Butterfly": {
    rarity: "Rare",
    location: "Flying near flowers",
    timeAvailable: "4 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 4000,
    northMonths: [11,0,1,2,5,6,7,8], 
    southMonths: [5,6,7,8,11,0,1,2], 
    description: "I caught an emperor butterfly! It's not your average monarch!"
  },

  "Agrias Butterfly": {
    rarity: "Rare",
    location: "Flying near flowers",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 3000,
    northMonths: [3,4,5,6,7,8], 
    southMonths: [9,10,11,0,1,2], 
    description: "I caught an agrias butterfly! I wonder if it finds me disagrias-able?"
  },

  "Rajah Brookes Birdwing": {
    rarity: "Rare",
    location: "Flying near flowers",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 2500,
    northMonths: [11,0,1,3,4,5,6,7,8], 
    southMonths: [5,6,7,9,10,11,0,1,2], 
    description: "I caught a Rajah Brooke's birdwing! Nothing else I'd rajah be doing!"
  },

  "Queen Alexandras Birdwing": {
    rarity: "Uncommon",
    location: "Flying near flowers",
    timeAvailable: "8 a.m - 4 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 50 total bugs",
    price: 4000,
    northMonths: [4,5,6,7,8], 
    southMonths: [10,11,0,1,2], 
    description: "I caught a Queen Alexandra's birdwing! That's a feather in my cap!"
  },

  "Moth": {
    rarity: "Common",
    location: "Flying near light sources",
    timeAvailable: "7 p.m - 4 a.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 130,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a moth! And I had a ball doing it!"
  },

  "Atlas Moth": {
    rarity: "Rare",
    location: "On trees (any kind)",
    timeAvailable: "7 p.m - 4 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 20 total bugs",
    price: 3000,
    northMonths: [3,4,5,6,7,8], 
    southMonths: [9,10,11,0,1,2], 
    description: "I caught an Atlas moth! I bet it never gets lost!"
  },

  "Madagascan Sunset Moth": {
    rarity: "Uncommon",
    location: "Flying near flowers",
    timeAvailable: "8 a.m - 4 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 2500,
    northMonths: [3,4,5,6,7,8], 
    southMonths: [9,10,11,0,1,2], 
    description: "I caught a Madagascan sunset moth! Wow, you're not from around here!"
  },

  "Long Locust": {
    rarity: "Common",
    location: "On the ground",
    timeAvailable: "8 a.m - 7 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 200,
    northMonths: [3,4,5,6,7,8,9,10], 
    southMonths: [9,10,11,0,1,2,3,4], 
    description: "I caught a long locust! Or, as I call it, a looooocust."
  },

  "Migratory Locust": {
    rarity: "Uncommon",
    location: "On the ground",
    timeAvailable: "8 a.m - 7 p.m",
    weather: "Any weather",
    spawnRequirements: "Catch 20 total bugs",
    price: 600,
    northMonths: [7,8,9,10], 
    southMonths: [1,2,3,4], 
    description: "I caught a migratory locust! Things just went south for this guy!"
  },

  "Rice Grasshopper": {
    rarity: "Uncommon",
    location: "On the ground",
    timeAvailable: "8 a.m - 7 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 400,
    northMonths: [7,8,9,10], 
    southMonths: [1,2,3,4], 
    description: "I caught a rice grasshopper! I've been looking for a gluten-free alternative..."
  },

  "Grasshopper": {
    rarity: "Common",
    location: "On the ground",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 160,
    northMonths: [6,7,8], 
    southMonths: [0,1,2], 
    description: "I caught a grasshopper! They're a grass act!"
  },

  "Cricket": {
    rarity: "Common",
    location: "On the ground",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 130,
    northMonths: [8,9,10], 
    southMonths: [2,3,4], 
    description: "I caught a cricket! What a chirp thrill!"
  },

  "Bell Cricket": {
    rarity: "Uncommon",
    location: "On the ground",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 430,
    northMonths: [8,9], 
    southMonths: [2,3], 
    description: "I caught a bell cricket! It would make a great bellhop!"
  },

  "Mantis": {
    rarity: "Uncommon",
    location: "On flowers",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 430,
    northMonths: [2,3,4,5,6,7,8,9,10], 
    southMonths: [8,9,10,11,0,1,2,3,4], 
    description: "I caught a mantis! Man, 'tis so cool!"
  },

  "Orchid Mantis": {
    rarity: "Uncommon",
    location: "On white flowers",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 2400,
    northMonths: [2,3,4,5,6,7,8,9,10], 
    southMonths: [8,9,10,11,0,1,2,3,4], 
    description: "I caught an orchid mantis! Our friendship is blooming!"
  },

  "Honeybee": {
    rarity: "Common",
    location: "Flying near flowers",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 200,
    northMonths: [2,3,4,5,6], 
    southMonths: [8,9,10,11,0], 
    description: "I caught a honeybee! Ah, sweet success!"
  },

  "Wasp": {
    rarity: "Common",
    location: "Shaking non-fruit hardwood trees or cedar trees",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 2500,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a wasp! That's gotta sting..."
  },

  "Brown Cicada": {
    rarity: "Common",
    location: "On trees (hardwood and cedar)",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 250,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a brown cicada! Now it probably feels blue, cicada."
  },

  "Robust Cicada": {
    rarity: "Common",
    location: "On trees (hardwood and cedar)",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a robust cicada! It DOES seem pretty lively!\n\nI caught a robust cicada! Not so energetic in the rain, huh?"
  },

  "Giant Cicada": {
    rarity: "Common",
    location: "On trees (hardwood and cedar)",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any weather",
    spawnRequirements: "Catch 20 total bugs",
    price: 500,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a giant cicada! I guess it's PRETTY big...\n\nI caught a giant cicada! Guess it doesn't feel like singing in the rain!"
  },

  "Walker Cicada": {
    rarity: "Common",
    location: "On trees (hardwood and cedar)",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 400,
    northMonths: [7,8], 
    southMonths: [1,2], 
    description: "I caught a walker cicada! Pffft... I walk all the time and no one calls me \"Walker <Player>.\"\n\nI caught a walker cicada! It must hate getting its feet wet."
  },

  "Evening Cicada": {
    rarity: "Common",
    location: "On trees (hardwood and cedar)",
    timeAvailable: "4 a.m - 8 a.m & 4 p.m - 7 p.m",
    availableHours: [4,5,6,7,16,17,18,19],
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 550,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught an evening cicada! Better than an odding cicada...\"\n\nI caught an evening cicada! This time it's WETTER than an odding cicada."
  },

  "Cicada Shell": {
    rarity: "Uncommon",
    location: "On trees (hardwood and cedar)",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Catch 50 total bugs",
    price: 10,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I found a cicada shell! I'm glad the little guy came out of it!"
  },

  "Red Dragonfly": {
    rarity: "Common",
    location: "Flying near water",
    timeAvailable: "8 a.m - 7 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 180,
    northMonths: [8,9], 
    southMonths: [2,3], 
    description: "I caught a red dragonfly! Didn't even have to roll for initiative!"
  },

  "Darner Dragonfly": {
    rarity: "Common",
    location: "Flying near water",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 230,
    northMonths: [3,4,5,6,7,8,9], 
    southMonths: [9,10,11,0,1,2,3], 
    description: "I caught a darner dragonfly! It better watch its mouth!"
  },

  "Banded Dragonfly": {
    rarity: "Rare",
    location: "Flying near water",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 50 total bugs",
    price: 4500,
    northMonths: [4,5,6,7,8,9], 
    southMonths: [10,11,0,1,2,3], 
    description: "I did it! Did you see that? I caught a banded dragonfly!"
  },

  "Damselfly": {
    rarity: "Common",
    location: "Flying near water",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 500,
    northMonths: [10,11,0,1], 
    southMonths: [4,5,6,7], 
    description: "I caught a damselfly! Now it's a damselfly in distress!"
  },

  "Firefly": {
    rarity: "Common",
    location: "Flying near water",
    timeAvailable: "7 p.m - 4 a.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [5], 
    southMonths: [11], 
    description: "I caught a firefly! I'm on fire now!"
  },

  "Mole Cricket": {
    rarity: "Rare",
    location: "Underground",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 500,
    northMonths: [10,11,0,1,2,3,4], 
    southMonths: [4,5,6,7,8,9,10], 
    description: "I caught a mole cricket! I really dug it!"
  },

  "Pondskater": {
    rarity: "Uncommon",
    location: "On rivers and ponds",
    timeAvailable: "8 a.m - 7 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 130,
    northMonths: [4,5,6,7,8], 
    southMonths: [10,11,0,1,2], 
    description: "I caught a pondskater! Wonder if it can do a pond ollie..."
  },

  "Diving Beetle": {
    rarity: "Uncommon",
    location: "On rivers and ponds",
    timeAvailable: "8 a.m - 7 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 800,
    northMonths: [4,5,6,7,8], 
    southMonths: [10,11,0,1,2], 
    description: "I caught a diving beetle! Now I'm making a splash!"
  },

  "Giant Water Bug": {
    rarity: "Common",
    location: "On rivers and ponds",
    timeAvailable: "7 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 50 total bugs",
    price: 2000,
    northMonths: [3,4,5,6,7,8], 
    southMonths: [9,10,11,0,1,2], 
    description: "I caught a giant water bug! It should've stayed in the water!"
  },

  "Stinkbug": {
    rarity: "Uncommon",
    location: "On flowers",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 120,
    northMonths: [2,3,4,5,6,7,8,9], 
    southMonths: [8,9,10,11,0,1,2,3], 
    description: "I caught a stinkbug! It lives up to its name!"
  },

  "Man-Faced Stink Bug": {
    rarity: "Common",
    location: "On flowers",
    timeAvailable: "7 p.m - 8 a.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 1000,
    northMonths: [2,3,4,5,6,7,8,9], 
    southMonths: [8,9,10,11,0,1,2,3], 
    description: "I caught a man-faced stink bug! Reminds me of my uncle!"
  },

  "Ladybug": {
    rarity: "Common",
    location: "On flowers",
    timeAvailable: "8 a.m - 5 p.m",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 200,
    northMonths: [2,3,4,5,9], 
    southMonths: [3,8,9,10,11], 
    description: "I caught a ladybug! Sorry to disturb you, ma'am."
  },

  "Tiger Beetle": {
    rarity: "Uncommon",
    location: "On the ground",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 1500,
    northMonths: [1,2,3,4,5,6,7,8,9], 
    southMonths: [7,8,9,10,11,0,1,2,3], 
    description: "I caught a tiger beetle! I pounced first!"
  },

  "Jewel Beetle": {
    rarity: "Uncommon",
    location: "On tree stumps",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 2400,
    northMonths: [3,4,5,6,7], 
    southMonths: [9,10,11,0,1], 
    description: "I caught a jewel beetle! It's a real gem!"
  },

  "Violin Beetle": {
    rarity: "Uncommon",
    location: "On tree stumps",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 450,
    northMonths: [4,5,8,9,10], 
    southMonths: [2,3,4,10,11], 
    description: "I caught a violin beetle! Apparently I'm as fit as a fiddle!"
  },

  "Citrus Long-Horned Beetle": {
    rarity: "Common",
    location: "On tree stumps",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 350,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a citrus long-horned beetle! Orange you happy for me?"
  },

 "Rosalia Batesi Beetle": {
    rarity: "Uncommon",
    location: "On tree stumps",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Catch 20 total bugs",
    price: 3000,
    northMonths: [4,5,6,7,8], 
    southMonths: [10,11,0,1,2], 
    description: "I caught a rosalia batesi beetle! That's easier to do than say!"
  },

  "Blue Weevil Beetle": {
    rarity: "Uncommon",
    location: "On palm trees",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 800,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a blue weevil beetle! It's the lesser of blue weevils!"
  },

  "Dung Beetle": {
    rarity: "Uncommon",
    location: "Pushing snowballs",
    timeAvailable: "All Day",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 3000,
    northMonths: [11,0,1], 
    southMonths: [5,6,7], 
    description: "I caught a dung beetle! This species likes feces!"
  },

  "Earth-Boring Dung Beetle": {
    rarity: "Common",
    location: "On the ground",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [6,7,8], 
    southMonths: [0,1,2], 
    description: "I caught an earth-boring dung beetle! It's not boring at all!"
  },

   "Scarab Beetle": {
    rarity: "Rare",
    location: "On the ground",
    timeAvailable: "11 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 50 total bugs",
    price: 10000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a scarab beetle! It's just a dung beetle with better hobbies."
  },

   "Drone Beetle": {
    rarity: "Common",
    location: "On the ground",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 200,
    northMonths: [5,6,7], 
    southMonths: [11,0,1], 
    description: "I caught a drone beetle! Shouldn't you have more propellers?"
  },

   "Goliath Beetle": {
    rarity: "Rare",
    location: "On palm trees",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 100 total bugs",
    price: 8000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a goliath beetle! Am I a legend or what?"
  },

   "Saw Stag": {
    rarity: "Uncommon",
    location: "On trees (any kind)",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 2000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a saw stag! Now I can't unsee it!"
  },

   "Miyama Stag": {
    rarity: "Common",
    location: "On trees (any kind)",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a miyama stag! Its mandibles are jaw-dropping!"
  },

    "Giant Stag": {
    rarity: "Rare",
    location: "On trees (any kind)",
    timeAvailable: "11 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 50 total bugs",
    price: 10000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "Whoaaa! I caught a giant stag! I'm gonna need way bigger pockets..."
  },

    "Rainbow Stag": {
    rarity: "Rare",
    location: "On trees (any kind)",
    timeAvailable: "7 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 50 total bugs",
    price: 6000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a rainbow stag! Its rainbow armor is so shiny!"
  },

    "Cyclommatus Stag": {
    rarity: "Uncommon",
    location: "On trees (any kind)",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 100 total bugs",
    price: 8000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a cyclommatus stag! Those mandibles are a mouthful!"
  },

    "Golden Stag": {
    rarity: "Rare",
    location: "On palm trees",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 100 total bugs",
    price: 12000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "Wooooow! I caught a golden stag! Does this mean I can retire?"
  },

    "Giraffe Stag": {
    rarity: "Rare",
    location: "On palm trees",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 100 total bugs",
    price: 12000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a giraffe stag! Does that make it a longhorn?"
  },

    "Horned Dynastid": {
    rarity: "Uncommon",
    location: "On trees (any kind)",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 1350,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a horned dynastid! I'd hate to hear it honk that schnoz!"
  },

    "Horned Atlas": {
    rarity: "Rare",
    location: "On palm trees",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 100 total bugs",
    price: 8000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a horned atlas! I didn't even need a map!"
  },

    "Horned Elephant": {
    rarity: "Rare",
    location: "On palm trees",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 100 total bugs",
    price: 8000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a horned elephant! I think it's too small to ride..."
  },

    "Horned Hercules": {
    rarity: "Rare",
    location: "On palm trees",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 100 total bugs",
    price: 12000,
    northMonths: [6,7], 
    southMonths: [0,1], 
    description: "I caught a horned hercules! Guess I was stronger!"
  },

    "Walking Stick": {
    rarity: "Uncommon",
    location: "On trees (any kind)",
    timeAvailable: "5 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Catch 20 total bugs",
    price: 600,
    northMonths: [6,7,8,9,10], 
    southMonths: [0,1,2,3,4], 
    description: "I caught a walking stick! Check out its walking schtick! Look, these are the jokes, OK?"
  },

    "Walking Leaf": {
    rarity: "Uncommon",
    location: "Disguised under trees",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Catch 20 total bugs",
    price: 600,
    northMonths: [6,7,8], 
    southMonths: [0,1,2], 
    description: "I caught a walking leaf! It seems to be taking it in stride!"
  },

    "Bagworm": {
    rarity: "Uncommon",
    location: "Shaking trees (hardwood and cedar)",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 600,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a bagworm! Guess I'm a bragworm!"
  },

    "Ant": {
    rarity: "Common",
    location: "On/near spoiled turnips/candy/lollipops",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 80,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught an ant! TELL ME WHERE THE QUEEN IS!"
  },

    "Hermit Crab": {
    rarity: "Uncommon",
    location: "Disguised on shoreline",
    timeAvailable: "7 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a hermit crab! I think it wanted to be left alone!"
  },

    "Wharf Roach": {
    rarity: "Uncommon",
    location: "On beach rocks",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 200,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a wharf roach! This water-loving roach has no pier!"
  },

    "Fly": {
    rarity: "Common",
    location: "Flying near trash or rotten turnips",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 60,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a fly! I was just wingin' it..."
  },

    "Mosquito": {
    rarity: "Common",
    location: "Flying",
    timeAvailable: "5 p.m - 4 a.m",
    weather: "Any except rain",
    spawnRequirements: "Appears from the start of the game",
    price: 130,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I caught a mosquito! It's itching for a fight!"
  },

    "Flea": {
    rarity: "Rare",
    location: "On villagers",
    timeAvailable: "All Day",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 70,
    northMonths: [3,4,5,6,7,8,9,10], 
    southMonths: [9,10,11,0,1,2,3,4], 
    description: "I caught a flea! The curse is lifted."
  },

    "Snail": {
    rarity: "Uncommon",
    location: "On rocks and bushes",
    timeAvailable: "All Day",
    weather: "Rain only",
    spawnRequirements: "Appears from the start of the game",
    price: 250,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a snail! It's...not much to brag about."
  },

    "Pill Bug": {
    rarity: "Uncommon",
    location: "From hitting rocks",
    timeAvailable: "11 p.m - 4 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 250,
    northMonths: [8,9,10,11,0,1,2,3,4,5], 
    southMonths: [2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a pill bug! That's a tough act to swallow!"
  },

    "Centipede": {
    rarity: "Uncommon",
    location: "From hitting rocks",
    timeAvailable: "4 p.m - 11 p.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 300,
    northMonths: [8,9,10,11,0,1,2,3,4,5], 
    southMonths: [2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a centipede! 99 more and I'll have a dollarpede!"
  },

    "Spider": {
    rarity: "Uncommon",
    location: "Shaking trees",
    timeAvailable: "7 p.m - 8 a.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 600,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I caught a spider! I spied 'er first!"
  },

    "Tarantula": {
    rarity: "Rare",
    location: "On the ground",
    timeAvailable: "7 p.m - 4 a.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 8000,
    northMonths: [10,11,0,1,2,3], 
    southMonths: [4,5,6,7,8,9], 
    description: "I caught a tarantula! This situation just got hairy!"
  },

    "Scorpion": {
    rarity: "Rare",
    location: "On the ground",
    timeAvailable: "7 p.m - 4 a.m",
    weather: "Any weather",
    spawnRequirements: "Appears from the start of the game",
    price: 8000,
    northMonths: [4,5,6,7,8,9], 
    southMonths: [10,11,0,1,2,3], 
    description: "I caught a scorpion! It was a sting operation!"
  },

  // SEA CREATURES DATABASE
  "Seaweed": {
    rarity: "Uncommon",
    shadow: "Large",
    movement: "Stationary", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 600,
    northMonths: [9,10,11,0,1,2,3,4,5,6], 
    southMonths: [3,4,5,6,5,6,7,8,9,10,11,0], 
    description: "I got some seaweed! I couldn't kelp myself."
  },

  "Sea Grapes": {
    rarity: "Common",
    shadow: "Small",
    movement: "Stationary", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 900,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I got some sea grapes! Can't let these go sour."
  },

  "Sea Cucumber": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Very Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 500,
    northMonths: [10,11,0,1,2,3], 
    southMonths: [4,5,6,7,8,9], 
    description: "I got a sea cucumber! It's a bit cumbersome..."
  },

  "Sea Pig": {
    rarity: "Rare",
    shadow: "Small",
    movement: "Very Fast", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Catch 80 total sea creatures",
    price: 10000,
    northMonths: [10,11,0,1], 
    southMonths: [4,5,6,7], 
    description: "I got a sea pig! What's next? Air pigs?"
  },

  "Sea Star": {
    rarity: "Common",
    shadow: "Small",
    movement: "Very Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 500,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I got a sea star! Maybe it'll give me an autograph!"
  },

  "Sea Urchin": {
    rarity: "Common",
    shadow: "Small",
    movement: "Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 1700,
    northMonths: [4,5,6,7,8], 
    southMonths: [10,11,0,1,2], 
    description: "I got a sea urchin! Wasn't even 'earchin for it."
  },

  "Slate Pencil Urchin": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Medium", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 2000,
    northMonths: [4,5,6,7,8], 
    southMonths: [10,11,0,1,2], 
    description: "I got a slate pencil urchin! Its handwriting is gorgeous."
  },

  "Sea Anemone": {
    rarity: "Common",
    shadow: "Large",
    movement: "Stationary", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 500,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I got a sea anemone! The enemy of my anemone is my afrenome!"
  },

  "Moon Jellyfish": {
    rarity: "Common",
    shadow: "Small",
    movement: "Very slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 600,
    northMonths: [6,7,8], 
    southMonths: [0,1,2], 
    description: "I got a moon jellyfish! Now to find a sun peanutbutterfish."
  },

  "Sea Slug": {
    rarity: "Common",
    shadow: "Tiny",
    movement: "Very slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 600,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I got a sea slug! It's kinda salty about that."
  },

  "Pearl Oyster": {
    rarity: "Common",
    shadow: "Small",
    movement: "Medium", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 2800,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I got a pearl oyster! Aw, shucks. Don't clam up now!"
  },

  "Mussel": {
    rarity: "Common",
    shadow: "Small",
    movement: "Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 1500,
    northMonths: [5,6,7,8,9,10,11], 
    southMonths: [11,0,1,2,3,4,5], 
    description: "I got a mussel! It's been working out"
  },

  "Oyster": {
    rarity: "Common",
    shadow: "Small",
    movement: "Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 1100,
    northMonths: [8,9,10,11,0,1], 
    southMonths: [2,3,4,5,6,7], 
    description: "I got an oyster! It's a little shellfish."
  },

  "Scallop": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 5 total sea creatures",
    price: 1200,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I got a scallop! It otter be savored."
  },

  "Whelk": {
    rarity: "Common",
    shadow: "Small",
    movement: "Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I got a whelk! Happy snails to ya."
  },

  "Turban Shell": {
    rarity: "Common",
    shadow: "Small",
    movement: "Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 1000,
    northMonths: [2,3,4,8,9,10,11], 
    southMonths: [2,3,4,5,8,9,10], 
    description: "I got a turban shell! It's totally TURB...ular!"
  },

  "Abalone": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Medium", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 2000,
    northMonths: [5,6,7,8,9,10,11,0], 
    southMonths: [11,0,1,2,3,4,5,6], 
    description: "I got an abalone! Why do I want a sandwich now?"
  },

  "Gigas Giant Clam": {
    rarity: "Common",
    shadow: "Very Large",
    movement: "Very Fast", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 80 total sea creatures",
    price: 15000,
    northMonths: [4,5,6,7,8], 
    southMonths: [10,11,0,1,2], 
    description: "I got a gigas giant clam! It's kind of a big deal."
  },

  "Chambered Nautilus": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Medium", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 1800,
    northMonths: [2,3,4,5,8,9,10], 
    southMonths: [2,3,4,8,9,10,11], 
    description: "I got a chambered nautilus! Is it on the naughty list?"
  },

  "Umbrella Octopus": {
    rarity: "Common",
    shadow: "Small",
    movement: "Fast", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 40 total sea creatures",
    price: 6000,
    northMonths: [2,3,4,8,9,10], 
    southMonths: [2,3,4,8,9,10], 
    description: "I got an umbrella octopus! Too bad I'm already soaked."
  },

  "Vampire Squid": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Very Fast", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Catch 80 total sea creatures",
    price: 10000,
    northMonths: [4,5,6,7], 
    southMonths: [10,11,0,1], 
    description: "I got a vampire squid! A lot was at stake."
  },

  "Firefly Squid": {
    rarity: "Common",
    shadow: "Tiny",
    movement: "Slow", 
    timeAvailable: "9 p.m - 4 a.m",
    spawnRequirements: "Appears from the start of the game",
    price: 1400,
    northMonths: [2,3,4,5], 
    southMonths: [8,9,10,11], 
    description: "I got a firefly squid! More like a glowswim squid."
  },

  "Gazami Crab": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Medium", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 2200,
    northMonths: [5,6,7,8,9,10], 
    southMonths: [11,0,1,2,3,4], 
    description: "I got a gazami crab! What a gripping find!"
  },

  "Dungeness Crab": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Medium", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 1900,
    northMonths: [10,11,0,1,2,3,4], 
    southMonths: [4,5,6,7,8,9,10], 
    description: "I got a Dungeness crab! Dun dun duuuun...geness."
  },

  "Snow Crab": {
    rarity: "Common",
    shadow: "Large",
    movement: "Fast", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 40 total sea creatures",
    price: 6000,
    northMonths: [10,11,0,1,2,3], 
    southMonths: [4,5,6,7,8,9], 
    description: "I got a snow crab! It's giving me the cold shoulder."
  },

  "Red King Crab": {
    rarity: "Common",
    shadow: "Large",
    movement: "Very Fast", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 80 total sea creatures",
    price: 8000,
    northMonths: [10,11,0,1,2], 
    southMonths: [4,5,6,7,8], 
    description: "I caught a red king crab! It's royally flushed."
  },

  "Acorn Barnacle": {
    rarity: "Common",
    shadow: "Tiny",
    movement: "Stationary", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 600,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I got an acorn barnacle! Will it grow into an oak barnacle?"
  },

  "Spider Crab": {
    rarity: "Common",
    shadow: "Very Large",
    movement: "Very Fast", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 80 total sea creatures",
    price: 12000,
    northMonths: [2,3], 
    southMonths: [8,9], 
    description: "I got a spider crab! Water bugs can rest easy."
  },

  "Tiger Prawn": {
    rarity: "Common",
    shadow: "Small",
    movement: "Medium", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 3000,
    northMonths: [5,6,7,8], 
    southMonths: [11,0,1,2], 
    description: "I got a tiger prawn! I ain't lion!"
  },

  "Sweet Shrimp": {
    rarity: "Common",
    shadow: "Small",
    movement: "Slow", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Appears from the start of the game",
    price: 1400,
    northMonths: [8,9,10,11,0,1], 
    southMonths: [2,3,4,5,6,7], 
    description: "I got a sweet shrimp! It's being very considerate."
  },

  "Mantis Shrimp": {
    rarity: "Common",
    shadow: "Small",
    movement: "Medium", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 2500,
    northMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    southMonths: [0,1,2,3,4,5,6,7,8,9,10,11], 
    description: "I got a mantis shrimp! Shrimply amazing!"
  },

  "Spiny Lobster": {
    rarity: "Common",
    shadow: "Large",
    movement: "Fast", 
    timeAvailable: "9 p.m - 4 a.m",
    spawnRequirements: "Catch 40 total sea creatures",
    price: 5000,
    northMonths: [9,10,11], 
    southMonths: [3,4,5], 
    description: "I got a spiny lobster! It's got a lot of backbone!"
  },

  "Lobster": {
    rarity: "Common",
    shadow: "Large",
    movement: "Fast", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 40 total sea creatures",
    price: 4500,
    northMonths: [11,0,3,4,5], 
    southMonths: [5,6,9,10,11], 
    description: "I got a lobster! Lobjective complete."
  },

  "Giant Isopod": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Very Fast", 
    timeAvailable: "9 a.m - 4 p.m & 9 p.m - 4 a.m",
    availableHours: [9,10,11,12,13,14,15,16,21,22,23,24,0,1,2,3,4],
    spawnRequirements: "Catch 80 total sea creatures",
    price: 12000,
    northMonths: [6,7,8,9], 
    southMonths: [0,1,2,3], 
    description: "GAAAAH! I got a giant isopod! It's the crustodian of the sea."
  },

  "Horseshoe Crab": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Medium", 
    timeAvailable: "9 p.m - 4 a.m",
    spawnRequirements: "Catch 20 total sea creatures",
    price: 2500,
    northMonths: [6,7,8], 
    southMonths: [0,1,2], 
    description: "I got a horseshoe crab! I hope it's lucky!"
  },

  "Sea Pineapple": {
    rarity: "Common",
    shadow: "Small",
    movement: "Slow", 
    timeAvailable: "All Day",
    spawnRequirements: "Appears from the start of the game",
    price: 1500,
    northMonths: [3,4,5,6,7], 
    southMonths: [9,10,11,0,1], 
    description: "I got a sea pineapple! Your move, sea pizzas."
  },

  "Spotted Garden Eel": {
    rarity: "Common",
    shadow: "Small",
    movement: "Slow", 
    timeAvailable: "4 a.m - 9 p.m",
    spawnRequirements: "Appears from the start of the game",
    price: 1100,
    northMonths: [4,5,6,7,8,9], 
    southMonths: [10,11,0,1,2,3], 
    description: "I got a spotted garden eel! Was it un-spotted before I saw it?"
  },

  "Flatworm": {
    rarity: "Common",
    shadow: "Tiny",
    movement: "Very Slow", 
    timeAvailable: "4 p.m - 9 a.m",
    spawnRequirements: "Appears from the start of the game",
    price: 700,
    northMonths: [7,8], 
    southMonths: [1,2], 
    description: "I got a flatworm! Guess it forgot its spareworm."
  },

  "Venus' Flower Basket": {
    rarity: "Common",
    shadow: "Medium",
    movement: "Fast", 
    timeAvailable: "All Day",
    spawnRequirements: "Catch 40 total sea creatures",
    price: 5000,
    northMonths: [9,10,11,0,1], 
    southMonths: [3,4,5,6,7], 
    description: "I got a Venus' flower basket! Why was she picking flowers here?"
  },

};

// convert time string to actuall hours in array
const parseTimeAvailable = (timeString) => {
  if (!timeString) return Array.from({length: 24}, (_, i) => i);
  
  const timeStr = timeString.toLowerCase().trim();
  
  // convert "All Day" to 24 hours in array
  if (timeStr.includes('all day') && !timeStr.includes('\nall day')) {
    return Array.from({length: 24}, (_, i) => i);
  }
  
  // parse time strings into hours in array. ex like "4pm - 9am", "9am - 4pm", "4 a.m - 9 p.m", etc.
  const timeRangeMatch = timeStr.match(/(\d+)\s*(a\.?m\.?|p\.?m\.?)\s*-\s*(\d+)\s*(a\.?m\.?|p\.?m\.?)/);
  if (timeRangeMatch) {
    const [, startHour, startPeriod, endHour, endPeriod] = timeRangeMatch;
    
    // Convert to 24-hour format
    let start = parseInt(startHour);
    let end = parseInt(endHour);
    
    //remove dots and spaces, make lowercase
    const normalizedStartPeriod = startPeriod.replace(/\./g, '').toLowerCase();
    const normalizedEndPeriod = endPeriod.replace(/\./g, '').toLowerCase();
    
    if (normalizedStartPeriod === 'pm' && start !== 12) start += 12;
    if (normalizedStartPeriod === 'am' && start === 12) start = 0;
    if (normalizedEndPeriod === 'pm' && end !== 12) end += 12;
    if (normalizedEndPeriod === 'am' && end === 12) end = 0;
    
    const hours = [];
    
    // Handle ranges taht covers from one day to another (ex 4 p.m - 9 a.m)
    if (start > end) {
      // From start hour to 23rd hours
      for (let i = start; i <= 23; i++) {
        hours.push(i);
      }
      // From 0 to end hour (exclusive)
      for (let i = 0; i < end; i++) {
        hours.push(i);
      }
    } else {
      //normal range (e.g., 9am - 4pm) - end hour is exclusive
      for (let i = start; i < end; i++) {
        hours.push(i);
      }
    }
    
    return hours;
  }
  
  // Single time formats like "9am", "4pm", "9 a.m", "4 p.m" adding single hour to array
  const singleTimeMatch = timeStr.match(/(\d+)\s*(a\.?m\.?|p\.?m\.?)/);
  if (singleTimeMatch) {
    const [, hour, period] = singleTimeMatch;
    let convertedHour = parseInt(hour);
    
    //remove dots and spaces, make lowercase
    const normalizedPeriod = period.replace(/\./g, '').toLowerCase();
    
    if (normalizedPeriod === 'pm' && convertedHour !== 12) convertedHour += 12;
    if (normalizedPeriod === 'am' && convertedHour === 12) convertedHour = 0;
    
    return [convertedHour];
  }
  
  // Default to all day if can't parse or nothing is written
  return Array.from({length: 24}, (_, i) => i);
};

//function to get creature info
export const getCreatureInfo = (creatureName, category = null) => {
  const info = creatureDatabase[creatureName];
  if (!info) {
    // Return default info if creature not found in database
    const basePrice = Math.floor(Math.random() * 2000) + 100;
    return {
      rarity: "Common",
      location: "Unknown",
      timeAvailable: "All day",
      availableHours: Array.from({length: 24}, (_, i) => i),
      shadow: "Medium",
      price: basePrice,
      cjPrice: category === 'fish' ? Math.floor(basePrice * 1.5) : undefined,
      flickPrice: category === 'bug' ? Math.floor(basePrice * 1.5) : undefined,
      northMonths: [0,1,2,3,4,5,6,7,8,9,10,11],
      southMonths: [0,1,2,3,4,5,6,7,8,9,10,11],
      description: `${creatureName.toLowerCase()}`,
    };
  }
  
  // Determine creature category
  const creatureCategory = category || determineCreatureCategory(creatureName);
  
  //calculate flick or c.j prices based on category
  let result = { ...info };
  
  if (creatureCategory === 'fish') {
    result.cjPrice = info.cjPrice || Math.floor(info.price * 1.5);
    delete result.flickPrice; // Remove if it exists
  } else if (creatureCategory === 'bug') {
    result.flickPrice = info.flickPrice || info.cjPrice || Math.floor(info.price * 1.5);
    delete result.cjPrice; // Remove if it exists
  } else {
    // Sea creatures - remove both special prices
    delete result.cjPrice;
    delete result.flickPrice;
  }
  
  //generate availableHours from timeAvailable if not provided
  result.availableHours = info.availableHours || parseTimeAvailable(info.timeAvailable);
  
  return result;
};

//determine creature category based on data files
const determineCreatureCategory = (creatureName) => {
  // Check if creature exists in fishData
  if (fishData.some(fish => fish.name === creatureName)) {
    return 'fish';
  }
  
  // Check if creature exists in bugData
  if (bugData.some(bug => bug.name === creatureName)) {
    return 'bug';
  }
  
  // Check if creature exists in seaData
  if (seaData.some(sea => sea.name === creatureName)) {
    return 'sea';
  }
  
  return 'unknown';
};

//function to check if creature is available in a specific month
export const isAvailableInMonth = (creatureName, month, hemisphere = 'north') => {
  const info = getCreatureInfo(creatureName);
  const availableMonths = hemisphere === 'north' ? info.northMonths : info.southMonths;
  return availableMonths.includes(month);
};

//function to check if creature is available at a specific hour
export const isAvailableAtHour = (creatureName, hour) => {
  const info = getCreatureInfo(creatureName);
  return info.availableHours.includes(hour);
};